"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.certificateMapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _CertificateProfile = _interopRequireWildcard(require("./CertificateProfile"));

var _CertificatePDF = _interopRequireDefault(require("./CertificatePDF"));

var _ = require("..");

var _excluded = ["product", "productionUnit", "labels", "key", "renderKey", "isAttest", "pdf"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      // maxWidth: 345,
      position: 'relative',
      margin: theme.spacing(3) // margin: 0,

    },
    pdf: {},
    dialog: {
      maxWidth: 1920
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var CertificateListItem = function CertificateListItem(_ref) {
  var extraClasses = _ref.classes,
      noMedia = _ref.noMedia,
      className = _ref.className,
      onClick = _ref.onClick,
      coverSrc = _ref.coverSrc,
      pdfSrc = _ref.pdfSrc,
      coverTitle = _ref.coverTitle,
      title = _ref.title,
      subTitle = _ref.subTitle,
      profileProps = _ref.profileProps,
      key = _ref.key,
      pdfWidth = _ref.pdfWidth;
  var classes = useStyles({
    classes: extraClasses
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    className: classes.root,
    key: key
  }, /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
    onClick: onClick
  }, !noMedia ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, coverSrc && /*#__PURE__*/_react["default"].createElement(_core.CardMedia, {
    className: classes.media,
    image: coverSrc,
    title: coverTitle
  }), /*#__PURE__*/_react["default"].createElement(_core.CardContent, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true,
    variant: "h5",
    component: "h2"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true,
    variant: "body2"
  }, subTitle))) : '', !noMedia && pdfSrc ? /*#__PURE__*/_react["default"].createElement(_CertificatePDF["default"], {
    src: pdfSrc,
    width: pdfWidth,
    classes: {
      root: classes.pdf
    }
  }) : '', /*#__PURE__*/_react["default"].createElement(_CertificateProfile["default"], profileProps)));
};

var certificateMapper = function certificateMapper(_ref2, unit, manufacturer, tLabels) {
  var product = _ref2.product,
      productionUnit = _ref2.productionUnit,
      labels = _ref2.labels,
      key = _ref2.key,
      renderKey = _ref2.renderKey,
      isAttest = _ref2.isAttest,
      pdf = _ref2.pdf,
      other = _objectWithoutProperties(_ref2, _excluded);

  var _manufacturer = manufacturer || productionUnit && productionUnit.manufacturer;

  var _unit = unit || productionUnit;

  var cover = product && product.cover;
  return {
    coverSrc: cover && cover.src,
    coverTitle: _manufacturer && _manufacturer.title,
    pdfSrc: pdf && pdf.src,
    title: renderKey,
    subTitle: isAttest ? /*#__PURE__*/_react["default"].createElement(_core.Box, {
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_.Label, {
      warning: true
    }, tLabels.attest), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      style: {
        marginLeft: 8
      }
    }, product && product.renderCodes)) : product && product.renderCodes,
    profileProps: (0, _CertificateProfile.certificateMapper)(_objectSpread({
      _unit: _unit
    }, other), _unit, _manufacturer, true, tLabels)
  };
};

exports.certificateMapper = certificateMapper;
CertificateListItem.propTypes = {
  className: _propTypes["default"].string,
  certificate: _propTypes["default"].object.isRequired,
  hideHeader: _propTypes["default"].bool.isRequired,
  hideOwner: _propTypes["default"].bool.isRequired,
  pdfWidth: _propTypes["default"].number
};
CertificateListItem.defaultProps = {
  className: '',
  hideHeader: false,
  hideOwner: false
};
var _default = CertificateListItem;
exports["default"] = _default;